import React, { type FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { type License } from '../../../interfaces';
import { SectionContainer } from '../../Other/SectionContainer';
import { LicenseAndRegistrationsForm } from './LicensesAndRegistrationsForm';

interface LicensesAndRegistrationsProps {
    providerId: number,
    licenses?: License[],
    onLicensesUpdated: (licenses: License[]) => void
}

export const LicensesAndRegistrations: FC<LicensesAndRegistrationsProps> = (props) => {
    const { licenses, providerId, onLicensesUpdated } = props;
    const { t, ready: translationsReady } = useTranslation('providerprofile', { useSuspense: false });

    const [cachePendingUpdate, setCachePendingUpdate] = useState(false);

    useEffect(() => {
        setCachePendingUpdate(false);
    }, [licenses]);

    return !translationsReady
        ? <></>
        : <SectionContainer title={t('licenses_registrations__section_title')}>
            {
                [...(licenses || []), undefined]?.map((license, index) => (
                    <LicenseAndRegistrationsForm
                        key={index}
                        providerId={providerId}
                        license={license}
                        licenses={licenses}
                        cachePendingUpdate={cachePendingUpdate}
                        onLicensesUpdated={onLicensesUpdated}
                    />
                ))
            }
        </SectionContainer>
}